let interval = setInterval(function(){
  let selected = document.querySelector('.max-bundles__discount.selected');
  if(selected) {
    clearInterval(interval);
    selected.style.background = 'rgba(142, 39, 136, 0.13)';
    selected.style.border = '1px solid black'

    let item = document.querySelectorAll('.max-bundles__discount');
    for(let i = 0; i < item.length; i++) {
      item[i].addEventListener('click', function(){
        if(item[i].classList.contains('selected')){
          item[i].style.background = 'rgba(142, 39, 136, 0.13)';
          item[i].style.border = '1px solid black'
        }
      })
    }
  }
},100)

